import { render } from "./RestrictPrompt.vue?vue&type=template&id=44d4dfb3&scoped=true"
import script from "./RestrictPrompt.vue?vue&type=script&lang=js"
export * from "./RestrictPrompt.vue?vue&type=script&lang=js"

import "./RestrictPrompt.vue?vue&type=style&index=0&id=44d4dfb3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44d4dfb3"

export default script